// @flow
import React from 'react';
import {withStyles} from '@material-ui/core/styles';
import styles from './HomeNews.styles.js';
import api from 'utils/API';
import {POSITION_BETWEEN_POSTS} from 'app/constants/ads';
import CategoryArchiveItem from 'app/components/CategoryArchiveItem';
import AdsBox from 'app/components/AdsBox';
import WidgetYektanet from 'app/components/WidgetYektanet';
import Button from 'app/components/Button';
// import latestNews from 'app/redux/'

type Props = {
  classes: any
};

type State = {
  list: Array<any>,
  page: number
};

class HomeNews extends React.Component<Props, State> {
  unmounted = false;

  constructor(props) {
    super(props);

    this.state = {
      list: [],
      page: 1
    };
  }

  listFill = (count = 30) => {
    return new Array(30).concat().fill({});
  }

  fetch = () => {
    let page = this.state.page;
    const count = 30;
    // fill with empty array to show Skeleton before server response
    const filledList = this.listFill(count);
    const data = {page, count};

    this.setState({
      list: [...this.state.list, ...filledList]
    });

    api.post('/pages/featurednews', data)
    .then(response => {
      if (this.unmounted) {
        return;
      }
      
      const appendList = response.data.list || [];
      // Total items with real data (none Skeleton items)
      const length = this.state.list.length - count;
      let list = [];
      for (let i = 0; i < length; i++) {
        list = [...list, {...this.state.list[i]}];
      }
      list = [...list, ...appendList];
      page += 1;
      this.setState({page, list});
    });
  }

  componentDidMount() {
    this.fetch();
  }

  componentWillUnmount() {
    this.unmounted = true;
  }

  render() {
    const {classes} = this.props;

    return (
      <div>
        {this.state.list.map((newsItem, index) => {
          const category = (newsItem.category && newsItem.category[0]) || {};
          return (
            <React.Fragment key={newsItem.name || index}>
              {index === 3 && 
                <AdsBox position={POSITION_BETWEEN_POSTS} />
              }
              {index === 6 && 
                <WidgetYektanet method="banner" idNumber="4980" />
                // <AdsBox position={POSITION_BETWEEN_POSTS} />
              }
              <CategoryArchiveItem
                data={newsItem}
                category={category.id}
                className={classes.card}
              />
            </React.Fragment>
          );
        })}

        <Button block text="بارگذاری موارد بیشتر" onClick={this.fetch} />
      </div>
    );
  }
}

// const mapStateToProps = state => ({ list: state.latestNews });

const Component = withStyles(styles)(HomeNews);
export {Component as HomeNews};
export default Component;